export function getAllKpis(): [{ field: string; headerName: string }] {
  const kpis: any = [];
  kpis.push(
    { field: "nbi_mtd", headerName: "NBI MTD" },
    { field: "nbi_ytd", headerName: "NBI YTD" },
    { field: "nbi_ytd_1", headerName: "NBI YTD-1" },
    { field: "nbi_ytd_var_yoy", headerName: "NBI YTD var YoY" },
    { field: "nbi_fy_1", headerName: "NBI FY-1" },
    { field: "nbi_mtd_1", headerName: "NBI MTD Y-1" },
    { field: "nbi_rwa_avg", headerName: "RWA AVG YTD" },
    { field: "nbi_rgcp", headerName: "RGCP AVG YTD" },
    { field: "nbi_h1", headerName: "NBI H1" },
    { field: "nbi_forcast_y1", headerName: "NBI Forecast YR1" },
    { field: "nbi_forcast_rwa_y1", headerName: "RWA Forecast YR1" },
    { field: "nbi_rwa_vs_fy_1", headerName: "RWA YTD vs FY-1" },
    { field: "nbi_rgcp_1", headerName: "RGCP FY-1" },
    { field: "nbi_rgcp_vs_fy_1", headerName: "RGCP YTD vs FY-1" },
    { field: "nbi_ytd_gbis", headerName: "NBI YTD-GBIS" },
    { field: "nbi_ytd_ib", headerName: "NBI YTD-IB" },
    { field: "nbi_ytd_nongbis", headerName: "NBI YTD-Non GBIS" },
    { field: "nbi_ytd_ib_1", headerName: "NBI YTD-1 IB" },
    { field: "nbi_ytd_1_gbis", headerName: "NBI YTD-1 GBIS" },
    { field: "nbi_ytd_2_gbis", headerName: "NBI YTD-2 GBIS" },
    { field: "nbi_ytd_3_gbis", headerName: "NBI YTD-3 GBIS" },
    { field: "nbi_fy_var_yoy", headerName: "NBI FY var YoY" },
    { field: "nbi_ytd_2", headerName: "NBI YTD Y-2" },
    { field: "nbi_ytd_3", headerName: "NBI YTD Y-3" },
    { field: "nbi_fy_1_ib", headerName: "NBI FY-1 - IB" },
    { field: "nbi_fy_2_ib", headerName: "NBI FY-2 - IB" },
    { field: "nbi_fy_3_ib", headerName: "NBI FY-3 - IB" },
    { field: "nbi_fy_1_gbis", headerName: "NBI FY-1 - GBIS" },
    { field: "nbi_fy_2", headerName: "NBI FY Y-2" },
    { field: "nbi_fy_3", headerName: "NBI FY Y-3" },
    { field: "nbi_forcast_y1_gbis", headerName: "NBI Forecast YR1 - GBIS" },
    { field: "nbi_forcast_y1_ib", headerName: "NBI Forecast YR1 - IB" },
    {
      field: "nbi_forcast_y1_nongbis",
      headerName: "NBI Forecast YR1 - Non GBIS",
    },
    { field: "nbi_forcast_y1_var_yoy", headerName: "NBI Forecast YR1 var YoY" },
    { field: "nbi_rwa_gbis", headerName: "RWA AVG YTD - GBIS" },
    { field: "nbi_rwa_fy_1", headerName: "RWA AVG FY-1" },
    { field: "nbi_rwa_fy_1_gbis", headerName: "RWA AVG FY-1 - GBIS" },
    { field: "nbi_rwa_fy_2", headerName: "RWA AVG FY-2" },
    { field: "nbi_rwa_fy_3", headerName: "RWA AVG FY-3" },
    { field: "nbi_rwa_last_period", headerName: "RWA Last Period" },
    { field: "nbi_forcast_rwa_y1_gbis", headerName: "Rwa Forecast YR1 - GBIS" },
    { field: "nbi_forcast_rwa_y1_ib", headerName: "RWA Forecast YR1 - IB" },
    {
      field: "nbi_forcast_rwa_y1_nongbis",
      headerName: "Rwa Forecast YR1 - Non GBIS",
    },
    {
      field: "nbi_forecast_rwa_y1_vs_fy_1",
      headerName: "RWA Forecast YR1 vs FY-1",
    },
    {
      field: "nbi_forecast_rwa_y2_vs_fy_1",
      headerName: "RWA Forecast YR2 vs FY-1",
    },

    { field: "nbi_rgcp_gbis", headerName: "RGCP AVG YTD GBIS" },
    { field: "nbi_forcast_rgcp_y1", headerName: "RGCP Forecast YR1" },
    {
      field: "nbi_forcast_rgcp_y1_gbis",
      headerName: "RGCP Forecast- GBIS YR1",
    },
    { field: "nbi_rgcp_fy_1_gbis", headerName: "RGCP FY-1 - GBIS" },
    { field: "nbi_rgcp_fy_2", headerName: "RGCP FY-2" },
    { field: "nbi_rgcp_fy_3", headerName: "RGCP FY-3" },

    { field: "nbi_gbis_bud_obj", headerName: "NBI Budget Year" },
    { field: "nbi_ytd_vs_nbi_gbis_bud_obj", headerName: "NBI YTD vs Budget" },
    { field: "nbi_gbis_bud_obj_ib", headerName: "NBI Budget - IB" },
    {
      field: "nbi_ytd_vs_nbi_gbis_bud_obj_ib",
      headerName: "NBI YTD vs Budget - IB",
    },
    { field: "nbi_scbased_fy_1", headerName: "NBI SC based FY-1" },
    { field: "nbi_scbased_fy_2", headerName: "NBI SC based FY-2" },
    { field: "nbi_scbased_fy_1_ib", headerName: "NBI SC based FY-1 - IB" },
    { field: "nbi_scbased_fy_2_ib", headerName: "NBI SC based FY-2 - IB" }
  );
  return kpis;
}

export function getDefaultKpis(): [{ field: string; headerName: string }] {
  const defaultKpis: any = [];
  defaultKpis.push(
    { field: "nbi_mtd", headerName: "NBI MTD" },
    { field: "nbi_ytd", headerName: "NBI YTD" },
    { field: "nbi_ytd_1", headerName: "NBI YTD-1" },
    { field: "nbi_fy_var_yoy", headerName: "NBI FY var YoY" },
    { field: "nbi_fy_1", headerName: "NBI FY-1" },
    { field: "nbi_mtd_1", headerName: "NBI MTD Y-1" },
    { field: "nbi_rwa_avg", headerName: "RWA AVG YTD" },
    { field: "nbi_rgcp", headerName: "RGCP AVG YTD" },
    { field: "nbi_h1", headerName: "NBI H1" },
    { field: "nbi_forcast_y1", headerName: "NBI Forecast YR1" },
    { field: "nbi_forcast_rwa_y1", headerName: "RWA Forecast YR1" },
    { field: "nbi_rwa_vs_fy_1", headerName: "RWA YTD vs FY-1" },
    { field: "nbi_rgcp_vs_fy_1", headerName: "RGCP YTD vs FY-1" }
  );
  return defaultKpis;
}
